import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormSelectOption } from '../../../../form-controls/entities/form-select-option.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormCheckboxWithDropdownBaseComponent } from '../base-simple/form-checkbox-with-dropdown-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormCheckboxWithDropdownComplexBaseComponent } from '../base-complex/form-checkbox-with-dropdown-complex-base.component';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { NgTemplateOutlet, NgClass, AsyncPipe } from '@angular/common';
import { ShFormLabelComponent } from '../../_core/form-label/form-label.component';

@Component({
    selector: 'sh-form-checkbox-with-dropdown',
    templateUrl: './form-checkbox-with-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormLabelComponent, NgTemplateOutlet, ShActionItemComponent, ShFormCheckboxWithDropdownComplexBaseComponent, ReactiveFormsModule, NgClass, ShFormCheckboxWithDropdownBaseComponent, AsyncPipe]
})
export class ShFormCheckboxWithDropdownComponent extends ShBaseFormComponent {
    @Input() options!: FormSelectOption[];
    @Input() inverted?: boolean;
}
